import React, { useState } from 'react';
interface Tab {
  id: string;
  label: React.ReactNode;
  content: React.ReactNode;
  disabled?: boolean;
}
interface TabsProps {
  tabs: Tab[];
  defaultTab?: string;
  variant?: 'default' | 'pills' | 'underline' | 'boxed';
  fullWidth?: boolean;
  className?: string;
  onChange?: (tabId: string) => void;
}
const Tabs: React.FC<TabsProps> = ({
  tabs,
  defaultTab,
  variant = 'default',
  fullWidth = false,
  className = '',
  onChange
}) => {
  const initialTab = defaultTab || (tabs.length > 0 ? tabs[0].id : '');
  const [activeTab, setActiveTab] = useState(initialTab);
  const handleTabChange = (tabId: string) => {
    setActiveTab(tabId);
    if (onChange) onChange(tabId);
  };
  // Tab button styles based on variant
  const getTabStyles = (tab: Tab) => {
    const isActive = activeTab === tab.id;
    const isDisabled = tab.disabled;
    const baseStyles = 'py-2 px-4 font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2';
    const disabledStyles = 'opacity-50 cursor-not-allowed';
    const variantStyles = {
      default: `${isActive ? 'border-b-2 border-yellow-500 text-blue-900' : 'text-gray-500 hover:text-blue-700 hover:border-b-2 hover:border-blue-200'} border-b border-gray-200`,
      pills: `${isActive ? 'bg-blue-700 text-white' : 'text-gray-700 hover:bg-gray-100 hover:text-blue-700'} rounded-full`,
      underline: `${isActive ? 'border-b-2 border-yellow-500 text-blue-900' : 'border-b-2 border-transparent text-gray-500 hover:text-blue-700 hover:border-blue-200'}`,
      boxed: `${isActive ? 'bg-white border-t border-l border-r rounded-t-lg text-blue-900 -mb-px' : 'bg-gray-50 text-gray-700 hover:bg-gray-100 hover:text-blue-700'} border-b`
    };
    return `${baseStyles} ${variantStyles[variant]} ${isDisabled ? disabledStyles : ''}`;
  };
  return <div className={className} data-id="element-658">
      {/* Tab navigation */}
      <div className={`flex ${variant === 'boxed' ? 'border-b border-gray-200' : ''} ${fullWidth ? 'w-full' : 'flex-wrap'}`} data-id="element-659">
        {tabs.map(tab => <button key={tab.id} className={`${getTabStyles(tab)} ${fullWidth ? 'flex-1 text-center' : 'mr-2'}`} onClick={() => !tab.disabled && handleTabChange(tab.id)} disabled={tab.disabled} aria-selected={activeTab === tab.id} role="tab" data-id="element-660">
            {tab.label}
          </button>)}
      </div>
      {/* Tab content */}
      <div className="mt-4" data-id="element-661">
        {tabs.map(tab => <div key={tab.id} className={`transition-opacity duration-300 ${activeTab === tab.id ? 'block animate-fadeIn' : 'hidden'}`} role="tabpanel" data-id="element-662">
            {tab.content}
          </div>)}
      </div>
    </div>;
};
export default Tabs;